var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 417,
    height: 436,
    viewBox: "0 0 417 436",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2995_8323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.166992 20.2927C0.166992 9.08536 9.25234 0 20.4597 0H395.874C407.082 0 416.167 9.08534 416.167 20.2927V436H0.166992V20.2927Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.2866,
    y: 55.3701,
    width: 206.024,
    height: 140.382,
    rx: 10.1463,
    fill: "#14081E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.0098,
    y: 169.978,
    width: 177.561,
    height: 5.07317,
    rx: 2.53659,
    fill: "#352F3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0098 172.514C26.0098 171.113 27.1454 169.978 28.5464 169.978H67.2258V175.051H28.5463C27.1454 175.051 26.0098 173.915 26.0098 172.514Z",
    fill: "#971EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9449 123.968H95.6699V125.81H90.0196V116.044H91.9449V123.968ZM97.5728 117.997C97.2752 117.997 97.0147 117.89 96.7915 117.676C96.5776 117.453 96.4706 117.192 96.4706 116.895C96.4706 116.597 96.5776 116.337 96.7915 116.113C97.0147 115.89 97.2752 115.779 97.5728 115.779C97.8797 115.779 98.1401 115.89 98.3541 116.113C98.5773 116.337 98.6889 116.597 98.6889 116.895C98.6889 117.192 98.5773 117.453 98.3541 117.676C98.1401 117.89 97.8797 117.997 97.5728 117.997ZM96.6799 125.81V118.834H98.4796V125.81H96.6799ZM104.717 118.834H106.698L104.047 125.81H101.996L99.3456 118.834H101.327L103.015 123.717L104.717 118.834ZM108.814 123.061C109.056 123.935 109.711 124.373 110.781 124.373C111.469 124.373 111.99 124.14 112.344 123.675L113.794 124.512C113.106 125.507 112.092 126.005 110.753 126.005C109.6 126.005 108.674 125.656 107.977 124.959C107.279 124.261 106.93 123.382 106.93 122.322C106.93 121.271 107.275 120.396 107.963 119.699C108.651 118.992 109.535 118.639 110.614 118.639C111.637 118.639 112.478 118.992 113.139 119.699C113.808 120.406 114.143 121.28 114.143 122.322C114.143 122.554 114.12 122.801 114.073 123.061H108.814ZM108.786 121.666H112.344C112.241 121.192 112.027 120.838 111.702 120.606C111.386 120.373 111.023 120.257 110.614 120.257C110.13 120.257 109.73 120.383 109.414 120.634C109.098 120.875 108.888 121.22 108.786 121.666ZM123.603 126.005C122.133 126.005 120.92 125.517 119.962 124.54C119.004 123.563 118.525 122.359 118.525 120.927C118.525 119.485 119.004 118.281 119.962 117.313C120.92 116.337 122.133 115.848 123.603 115.848C124.487 115.848 125.3 116.058 126.044 116.476C126.798 116.885 127.384 117.443 127.802 118.15L126.142 119.113C125.9 118.676 125.556 118.336 125.11 118.095C124.663 117.843 124.161 117.718 123.603 117.718C122.654 117.718 121.887 118.015 121.301 118.611C120.724 119.206 120.436 119.978 120.436 120.927C120.436 121.866 120.724 122.633 121.301 123.229C121.887 123.824 122.654 124.121 123.603 124.121C124.161 124.121 124.663 124.001 125.11 123.759C125.565 123.508 125.91 123.168 126.142 122.74L127.802 123.703C127.384 124.41 126.802 124.972 126.058 125.391C125.314 125.8 124.496 126.005 123.603 126.005ZM129.01 125.81V115.625H130.81V125.81H129.01ZM137.759 118.834H139.558V125.81H137.759V124.986C137.219 125.665 136.461 126.005 135.485 126.005C134.554 126.005 133.755 125.651 133.085 124.945C132.425 124.228 132.094 123.354 132.094 122.322C132.094 121.289 132.425 120.42 133.085 119.713C133.755 118.997 134.554 118.639 135.485 118.639C136.461 118.639 137.219 118.978 137.759 119.657V118.834ZM134.438 123.745C134.801 124.108 135.261 124.289 135.819 124.289C136.377 124.289 136.838 124.108 137.201 123.745C137.573 123.373 137.759 122.898 137.759 122.322C137.759 121.745 137.573 121.275 137.201 120.913C136.838 120.541 136.377 120.355 135.819 120.355C135.261 120.355 134.801 120.541 134.438 120.913C134.076 121.275 133.894 121.745 133.894 122.322C133.894 122.898 134.076 123.373 134.438 123.745ZM142.796 120.815C142.796 121.001 142.917 121.155 143.159 121.275C143.41 121.387 143.712 121.489 144.066 121.582C144.419 121.666 144.772 121.778 145.126 121.917C145.479 122.047 145.777 122.271 146.019 122.587C146.27 122.903 146.395 123.298 146.395 123.773C146.395 124.489 146.126 125.042 145.586 125.433C145.056 125.814 144.391 126.005 143.591 126.005C142.159 126.005 141.182 125.451 140.661 124.345L142.224 123.466C142.429 124.07 142.884 124.373 143.591 124.373C144.233 124.373 144.554 124.173 144.554 123.773C144.554 123.587 144.428 123.438 144.177 123.326C143.935 123.205 143.638 123.098 143.284 123.005C142.931 122.912 142.577 122.796 142.224 122.657C141.871 122.517 141.568 122.299 141.317 122.001C141.075 121.694 140.954 121.313 140.954 120.857C140.954 120.169 141.206 119.629 141.708 119.239C142.219 118.839 142.852 118.639 143.605 118.639C144.173 118.639 144.689 118.769 145.154 119.029C145.619 119.28 145.986 119.643 146.256 120.117L144.721 120.955C144.498 120.48 144.126 120.243 143.605 120.243C143.373 120.243 143.177 120.294 143.019 120.396C142.87 120.499 142.796 120.638 142.796 120.815ZM148.845 120.815C148.845 121.001 148.966 121.155 149.208 121.275C149.459 121.387 149.761 121.489 150.115 121.582C150.468 121.666 150.822 121.778 151.175 121.917C151.528 122.047 151.826 122.271 152.068 122.587C152.319 122.903 152.445 123.298 152.445 123.773C152.445 124.489 152.175 125.042 151.635 125.433C151.105 125.814 150.44 126.005 149.64 126.005C148.208 126.005 147.231 125.451 146.711 124.345L148.273 123.466C148.478 124.07 148.934 124.373 149.64 124.373C150.282 124.373 150.603 124.173 150.603 123.773C150.603 123.587 150.477 123.438 150.226 123.326C149.985 123.205 149.687 123.098 149.333 123.005C148.98 122.912 148.627 122.796 148.273 122.657C147.92 122.517 147.617 122.299 147.366 122.001C147.125 121.694 147.004 121.313 147.004 120.857C147.004 120.169 147.255 119.629 147.757 119.239C148.269 118.839 148.901 118.639 149.654 118.639C150.222 118.639 150.738 118.769 151.203 119.029C151.668 119.28 152.035 119.643 152.305 120.117L150.77 120.955C150.547 120.48 150.175 120.243 149.654 120.243C149.422 120.243 149.226 120.294 149.068 120.396C148.92 120.499 148.845 120.638 148.845 120.815Z",
    fill: "#ADADAD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.9665,
    cy: 120.913,
    r: 3.80488,
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 416,
    height: 35.5122,
    transform: "translate(0.166992)",
    fill: "#352F3B"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2995_8323)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.431 16.0982C26.1064 16.0982 25.7945 16.0522 25.4951 15.9644C25.6877 16.2593 25.8405 16.5836 25.9494 16.9287C26.0792 17.3178 26.1441 17.7362 26.1441 18.1692C26.1441 20.4118 24.3268 22.2317 22.0782 22.2317C22.0259 22.2317 21.9756 22.2317 21.9233 22.2275L21.3308 22.8488L21.3119 22.8677L18.2991 26.0223C18.029 26.3047 17.581 26.3151 17.2983 26.0474L17.2104 25.9637C16.9299 25.6938 16.9173 25.2462 17.1874 24.9638L20.9141 21.0958L20.9497 21.0603C20.9497 21.0226 21.1905 19.3135 21.6616 18.6399L20.4179 19.9411C20.1478 20.2235 19.6998 20.2339 19.4171 19.9662L19.3292 19.8804C19.0466 19.6126 18.9921 19.1462 19.2601 18.8637L23.5186 14.4686C23.4496 14.3766 23.3826 14.2448 23.3218 14.0879C23.3197 14.0858 23.3197 14.0837 23.3197 14.0816C23.1418 13.634 23.0162 13.0106 23.0162 12.6863C23.0162 10.8015 24.5425 9.27441 26.4289 9.27441C27.3208 9.27441 28.131 9.6133 28.7403 10.1718L28.8261 15.1213C28.2127 15.7238 27.3668 16.0982 26.431 16.0982Z",
    fill: "#F4F4F4",
    stroke: "#1C1919",
    strokeWidth: 0.151491,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5097 14.4649L23.3108 14.672L21.73 16.3267L19.9986 18.0567L19.9651 18.0232L18.7696 16.8287L18.7235 16.7827L18.667 16.7262L21.5772 13.8164C22.0106 13.3854 22.7183 13.3854 23.1516 13.8164C23.1851 13.8498 23.2145 13.8854 23.2417 13.9251V13.9272C23.2752 14.0172 23.4845 14.4251 23.5097 14.4649Z",
    fill: "#F4F4F4",
    stroke: "#1C1919",
    strokeWidth: 0.151491,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7929 17.4531L21.6614 18.6381C21.6593 18.6402 21.6593 18.6423 21.6572 18.6444L22.7929 17.4531Z",
    stroke: "#1C1919",
    strokeWidth: 0.151491,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9888 18.0509L19.3502 18.7015L14.3924 23.743C14.384 23.7493 14.3777 23.7577 14.3693 23.7639C14.3149 23.81 14.25 23.833 14.183 23.833C14.1076 23.833 14.0343 23.8037 13.9757 23.7472C13.8606 23.6363 13.8522 23.4501 13.9632 23.333L13.3539 23.9585C13.2974 24.017 13.2199 24.0463 13.1445 24.0463C13.0692 24.0463 12.9959 24.0191 12.9394 23.9627C12.8221 23.8476 12.82 23.6614 12.9352 23.5464L14.1872 22.2515C14.1244 22.3142 14.0427 22.3498 13.9632 22.3498C13.8941 22.3498 13.8292 22.3247 13.7747 22.2724C13.6575 22.1573 13.6575 21.9732 13.7705 21.8561L18.7284 16.8125L19.9888 18.0509Z",
    fill: "#F4F4F4",
    stroke: "#1C1919",
    strokeWidth: 0.151491,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7874 20.4385L13.9645 23.3322C13.9624 23.3343 13.9624 23.3343 13.9624 23.3364L16.7874 20.4385Z",
    stroke: "#1C1919",
    strokeWidth: 0.151491,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.548 20.8477L14.1851 22.2534L15.548 20.8477Z",
    stroke: "#1C1919",
    strokeWidth: 0.151491,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8394 12.6841C29.8457 13.636 29.4165 14.4623 28.7863 15.0836L26.3032 12.6841L28.6984 10.2031C29.3097 10.8621 29.8332 11.6926 29.8394 12.6841Z",
    fill: "#971EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6318 10.626C28.9439 10.8394 29.2077 11.1323 29.3899 11.4734C29.5742 11.8123 29.6747 12.2015 29.6747 12.5928C29.6642 12.982 29.5763 13.3669 29.415 13.7164C29.3396 13.8921 29.2308 14.0511 29.1386 14.2185C29.0213 14.3692 28.9083 14.5219 28.7868 14.6663C28.8748 14.4989 28.8748 14.3441 28.9648 14.1809L29.08 13.9256C29.1156 13.8398 29.1658 13.7603 29.1889 13.6703C29.2454 13.4946 29.3145 13.323 29.3396 13.141C29.3878 12.9631 29.3899 12.779 29.4004 12.5991C29.4025 12.235 29.3166 11.8751 29.1679 11.5403C29.0172 11.2056 28.902 10.8896 28.6318 10.626Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7578 20.6255V18.5666L31.1768 16.1123H32.5903L33.1976 17.2756C33.2018 17.2819 33.208 17.2924 33.2164 17.3091C33.2792 17.4305 33.3253 17.5456 33.3483 17.6585C33.3693 17.5581 33.4133 17.4451 33.4803 17.3217C33.4928 17.2987 33.5012 17.284 33.5054 17.2756L34.1064 16.1123H35.522L33.941 18.5666V20.6255H32.7578Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9571 19.0766C38.9571 19.3005 38.9131 19.5139 38.8252 19.7148C38.7372 19.9157 38.6116 20.0977 38.4441 20.2567C38.2744 20.4178 38.086 20.5392 37.8786 20.6208C37.6692 20.7024 37.4473 20.7442 37.2127 20.7442C36.974 20.7442 36.7499 20.7024 36.5405 20.6208C36.3311 20.5392 36.1447 20.4178 35.9814 20.2567C35.816 20.0998 35.6903 19.9219 35.6044 19.719C35.5186 19.516 35.4746 19.3026 35.4746 19.0766C35.4746 18.8486 35.5165 18.6331 35.6024 18.4322C35.6882 18.2313 35.8139 18.0493 35.9814 17.8903C36.1447 17.7313 36.329 17.612 36.5384 17.5325C36.7478 17.453 36.9719 17.4111 37.2127 17.4111C37.4535 17.4111 37.6776 17.4509 37.8849 17.5325C38.0922 17.612 38.2786 17.7313 38.4441 17.8903C38.6137 18.0535 38.7414 18.2355 38.8273 18.4364C38.9131 18.6372 38.9571 18.8507 38.9571 19.0766ZM37.864 19.0766C37.864 18.8444 37.8054 18.6624 37.6881 18.5284C37.5708 18.3945 37.4117 18.3276 37.2127 18.3276C37.0117 18.3276 36.8525 18.3945 36.7353 18.5284C36.618 18.6624 36.5615 18.8444 36.5615 19.0766C36.5615 19.3089 36.618 19.4909 36.7353 19.6248C36.8504 19.7567 37.0096 19.8236 37.2127 19.8236C37.4138 19.8236 37.5729 19.7567 37.6902 19.6248C37.8074 19.493 37.864 19.3089 37.864 19.0766Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7868 17.5088V19.1011C42.7868 19.4526 42.7596 19.7141 42.7009 19.8836C42.6444 20.0531 42.5502 20.2037 42.4161 20.3355C42.2779 20.4736 42.1062 20.5762 41.901 20.6431C41.6958 20.7101 41.4529 20.7456 41.1764 20.7456C40.9 20.7456 40.6613 20.7122 40.4561 20.6431C40.2508 20.5762 40.077 20.4716 39.9325 20.3355C39.7985 20.2079 39.7043 20.0594 39.6477 19.8878C39.5912 19.7162 39.564 19.4547 39.564 19.1032V17.5109H40.6131V19.1722C40.6131 19.4337 40.6571 19.6221 40.7429 19.7371C40.8288 19.8543 40.9691 19.9108 41.1618 19.9108C41.3565 19.9108 41.4968 19.8543 41.5827 19.7392C41.6685 19.6262 41.7104 19.4358 41.7104 19.1701V17.5088H42.7868Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9469 20.6247L43.0518 16.1094H44.3606L45.2652 18.6348C45.2736 18.662 45.2904 18.7248 45.3155 18.8273C45.3406 18.9299 45.3741 19.0659 45.416 19.2395C45.4495 19.1014 45.4788 18.978 45.5081 18.8671C45.5375 18.7562 45.5584 18.6788 45.5731 18.6348L46.4714 16.1094H47.7803L45.8851 20.6247H44.9469Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4109 17.5095V20.625H50.4015V20.1186C50.257 20.3341 50.0958 20.4932 49.9157 20.5936C49.7356 20.694 49.5241 20.7442 49.2812 20.7442C48.8665 20.7442 48.5336 20.5936 48.2844 20.2902C48.0352 19.9868 47.9116 19.5809 47.9116 19.0704C47.9116 18.5619 48.0415 18.1581 48.3011 17.8589C48.5608 17.5597 48.9126 17.4111 49.3524 17.4111C49.5869 17.4111 49.79 17.4614 49.9597 17.5597C50.1293 17.6601 50.2759 17.8129 50.3973 18.02V17.5074H51.4109V17.5095ZM50.4455 19.0641C50.4455 18.8214 50.3806 18.6289 50.2507 18.4866C50.1209 18.3443 49.945 18.2732 49.7188 18.2732C49.4927 18.2732 49.3189 18.3443 49.189 18.4845C49.0613 18.6247 48.9964 18.8172 48.9964 19.062C48.9964 19.3047 49.0613 19.4951 49.1911 19.6353C49.321 19.7755 49.4969 19.8445 49.7188 19.8445C49.9429 19.8445 50.1209 19.7755 50.2507 19.6353C50.3806 19.4951 50.4455 19.3068 50.4455 19.0641Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2417 20.6248V15.8438H53.3223V17.5218C53.3223 17.6327 53.3202 17.7352 53.3139 17.8294C53.3076 17.9235 53.2992 18.0093 53.2867 18.0847C53.4249 17.8524 53.5861 17.6808 53.7746 17.572C53.961 17.4632 54.185 17.4088 54.4447 17.4088C54.6457 17.4088 54.8258 17.4423 54.9829 17.5051C55.1399 17.5699 55.2677 17.662 55.3661 17.7834C55.4478 17.888 55.5064 18.0156 55.542 18.1663C55.5776 18.3169 55.5944 18.5408 55.5944 18.8379V20.6206H54.4929V18.953C54.4929 18.704 54.4531 18.524 54.3714 18.4111C54.2897 18.2981 54.1599 18.2416 53.9819 18.2416C53.7536 18.2416 53.5861 18.3253 53.4814 18.4948C53.3767 18.6642 53.3244 18.9362 53.3244 19.315V20.6227H52.2417V20.6248Z",
    fill: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 323.497,
    y: 10.4844,
    width: 14.5431,
    height: 14.5431,
    rx: 2.42385,
    fill: "#554861"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.398 17.7559C374.398 23.7799 369.514 28.6633 363.49 28.6633C357.466 28.6633 352.583 23.7799 352.583 17.7559C352.583 11.732 357.466 6.84863 363.49 6.84863C369.514 6.84863 374.398 11.732 374.398 17.7559ZM354.661 17.7559C354.661 22.6325 358.614 26.5857 363.49 26.5857C368.367 26.5857 372.32 22.6325 372.32 17.7559C372.32 12.8794 368.367 8.92622 363.49 8.92622C358.614 8.92622 354.661 12.8794 354.661 17.7559Z",
    fill: "#554861"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M364.523 6.89885C363.952 6.84429 363.486 7.3145 363.486 7.88821C363.486 8.46192 363.952 8.9207 364.522 8.98804C365.84 9.14384 367.111 9.5955 368.237 10.3146C369.657 11.2208 370.787 12.5138 371.496 14.0413C372.204 15.5688 372.461 17.2671 372.236 18.9358C372.058 20.2602 371.582 21.5221 370.849 22.6291C370.814 22.6831 370.783 22.7394 370.756 22.7972C370.387 23.3189 369.961 23.8015 369.483 24.2352C368.237 25.3671 366.692 26.1189 365.032 26.402C363.373 26.6852 361.666 26.4878 360.115 25.8332C358.884 25.3137 357.791 24.5234 356.915 23.5262C356.536 23.0953 355.894 22.9712 355.421 23.2967C354.949 23.6222 354.826 24.2728 355.195 24.7122C356.303 26.0315 357.711 27.0737 359.307 27.7473C361.224 28.556 363.331 28.7998 365.382 28.45C367.432 28.1003 369.34 27.1715 370.88 25.7733C372.163 24.6086 373.146 23.1585 373.754 21.5465C373.788 21.4542 373.807 21.3608 373.812 21.2687C374.038 20.6038 374.201 19.9156 374.295 19.2133C374.573 17.1519 374.256 15.0541 373.38 13.1671C372.505 11.2802 371.109 9.68291 369.356 8.56354C367.895 7.63109 366.238 7.06268 364.523 6.89885Z",
    fill: "#971EFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.941,
    y: 10.4844,
    width: 14.5431,
    height: 14.5431,
    rx: 2.42385,
    fill: "#554861"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 416,
    height: 26.6341,
    transform: "translate(0.166992 205.897)",
    fill: "#EEE5F6"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-25-inside-1_2995_8323",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2861 205.897H50.1094V232.532H12.2861V205.897Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.2861 205.897H50.1094V232.532H12.2861V205.897Z",
    fill: "#CDBCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1094 230.629H12.2861V234.434H50.1094V230.629Z",
    fill: "#A08EB0",
    mask: "url(#path-25-inside-1_2995_8323)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.6523,
    y: 212.873,
    width: 50.7317,
    height: 12.6829,
    rx: 6.34146,
    fill: "#CDBCDC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.351,
    y: 212.873,
    width: 50.7317,
    height: 12.6829,
    rx: 6.34146,
    fill: "#CDBCDC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.05,
    y: 212.873,
    width: 50.7317,
    height: 12.6829,
    rx: 6.34146,
    fill: "#CDBCDC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.749,
    y: 212.873,
    width: 50.7317,
    height: 12.6829,
    rx: 6.34146,
    fill: "#CDBCDC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.104,
    y: 56.2942,
    width: 29.6921,
    height: 14.2417,
    rx: 2.12087,
    fill: "#EEE5F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.104,
    y: 56.2942,
    width: 29.6921,
    height: 14.2417,
    rx: 2.12087,
    stroke: "#CDBCDC",
    strokeWidth: 0.605962
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.444 61.325C242.142 61.325 242.724 61.5698 243.19 62.0594C243.66 62.549 243.895 63.1525 243.895 63.87C243.895 64.5875 243.66 65.191 243.19 65.6806C242.724 66.1702 242.142 66.415 241.444 66.415H239.423V61.325H241.444ZM241.444 65.4552C241.885 65.4552 242.244 65.3098 242.521 65.0189C242.797 64.7232 242.935 64.3402 242.935 63.87C242.935 63.3998 242.797 63.0192 242.521 62.7284C242.244 62.4327 241.885 62.2848 241.444 62.2848H240.426V65.4552H241.444ZM247.694 66.415L247.389 65.4988H245.36L245.055 66.415H243.971L245.753 61.325H246.996L248.785 66.415H247.694ZM245.68 64.5608H247.076L246.378 62.4811L245.68 64.5608ZM252.647 61.325L250.902 64.4299V66.415H249.906V64.4299L248.168 61.325H249.302L250.408 63.4482L251.513 61.325H252.647ZM255.879 66.415V65.431L257.873 63.361C258.274 62.9481 258.475 62.5975 258.475 62.309C258.475 62.1224 258.418 61.9725 258.305 61.8594C258.192 61.7406 258.037 61.6813 257.839 61.6813C257.443 61.6813 257.151 61.8962 256.965 62.326L255.82 61.6558C256 61.2316 256.272 60.9093 256.634 60.6887C256.996 60.4681 257.392 60.3578 257.822 60.3578C258.376 60.3578 258.848 60.5303 259.238 60.8753C259.634 61.2147 259.832 61.6728 259.832 62.2497C259.832 62.8774 259.524 63.4996 258.908 64.116L257.923 65.1086H259.917V66.415H255.879Z",
    fill: "#554861"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.371,
    y: 55.8057,
    width: 131.113,
    height: 15.2195,
    rx: 7.60976,
    fill: "#CDBCDC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.801,
    y: 81.1709,
    width: 168.683,
    height: 30.439,
    rx: 5.07317,
    fill: "#EEE5F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.801,
    y: 121.758,
    width: 168.683,
    height: 73.561,
    rx: 5.07317,
    fill: "#F0ECF3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.8501,
    y: 252.39,
    width: 205.463,
    height: 71.0244,
    rx: 10.1463,
    fill: "#F0ECF3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.8501,
    y: 338.635,
    width: 205.463,
    height: 110.341,
    rx: 10.1463,
    fill: "#F0ECF3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.533,
    y: 252.823,
    width: 169.951,
    height: 41.2054,
    rx: 7.27155,
    fill: "#EEE5F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.982,
    y: 266.305,
    width: 29.6921,
    height: 14.2417,
    rx: 2.12087,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.982,
    y: 266.305,
    width: 29.6921,
    height: 14.2417,
    rx: 2.12087,
    stroke: "#CDBCDC",
    strokeWidth: 0.605962
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.322 271.336C251.02 271.336 251.602 271.581 252.067 272.07C252.538 272.56 252.773 273.163 252.773 273.881C252.773 274.598 252.538 275.202 252.067 275.691C251.602 276.181 251.02 276.426 250.322 276.426H248.301V271.336H250.322ZM250.322 275.466C250.763 275.466 251.122 275.321 251.398 275.03C251.675 274.734 251.813 274.351 251.813 273.881C251.813 273.411 251.675 273.03 251.398 272.739C251.122 272.443 250.763 272.296 250.322 272.296H249.304V275.466H250.322ZM256.572 276.426L256.267 275.51H254.238L253.933 276.426H252.849L254.631 271.336H255.874L257.663 276.426H256.572ZM254.558 274.572H255.954L255.256 272.492L254.558 274.572ZM261.525 271.336L259.78 274.441V276.426H258.784V274.441L257.046 271.336H258.18L259.286 273.459L260.391 271.336H261.525ZM264.757 276.426V275.442L266.75 273.372C267.152 272.959 267.353 272.608 267.353 272.32C267.353 272.133 267.296 271.983 267.183 271.87C267.07 271.751 266.914 271.692 266.717 271.692C266.321 271.692 266.029 271.907 265.843 272.337L264.697 271.667C264.878 271.242 265.15 270.92 265.512 270.699C265.874 270.479 266.27 270.369 266.7 270.369C267.254 270.369 267.726 270.541 268.116 270.886C268.512 271.225 268.71 271.684 268.71 272.26C268.71 272.888 268.402 273.51 267.785 274.127L266.801 275.119H268.795V276.426H264.757Z",
    fill: "#554861"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.249,
    y: 263.279,
    width: 112.089,
    height: 20.2927,
    rx: 10.1463,
    fill: "#CDBCDC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.533,
    y: 301.301,
    width: 169.951,
    height: 41.2054,
    rx: 7.27155,
    fill: "#EEE5F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.982,
    y: 314.783,
    width: 29.6921,
    height: 14.2417,
    rx: 2.12087,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.982,
    y: 314.783,
    width: 29.6921,
    height: 14.2417,
    rx: 2.12087,
    stroke: "#CDBCDC",
    strokeWidth: 0.605962
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.322 319.814C251.02 319.814 251.602 320.059 252.067 320.549C252.538 321.038 252.773 321.642 252.773 322.359C252.773 323.077 252.538 323.68 252.067 324.17C251.602 324.659 251.02 324.904 250.322 324.904H248.301V319.814H250.322ZM250.322 323.944C250.763 323.944 251.122 323.799 251.398 323.508C251.675 323.212 251.813 322.829 251.813 322.359C251.813 321.889 251.675 321.508 251.398 321.218C251.122 320.922 250.763 320.774 250.322 320.774H249.304V323.944H250.322ZM256.572 324.904L256.267 323.988H254.238L253.933 324.904H252.849L254.631 319.814H255.874L257.663 324.904H256.572ZM254.558 323.05H255.954L255.256 320.97L254.558 323.05ZM261.525 319.814L259.78 322.919V324.904H258.784V322.919L257.046 319.814H258.18L259.286 321.938L260.391 319.814H261.525ZM267.718 321.375C268.096 321.505 268.402 321.717 268.634 322.011C268.866 322.3 268.982 322.642 268.982 323.038C268.982 323.66 268.772 324.146 268.354 324.497C267.935 324.848 267.423 325.023 266.818 325.023C266.349 325.023 265.928 324.916 265.554 324.701C265.187 324.486 264.915 324.169 264.74 323.751L265.911 323.072C266.058 323.49 266.36 323.7 266.818 323.7C267.084 323.7 267.285 323.637 267.421 323.513C267.556 323.389 267.624 323.23 267.624 323.038C267.624 322.846 267.556 322.687 267.421 322.563C267.285 322.438 267.084 322.376 266.818 322.376H266.538L266.021 321.604L267.098 320.238H264.927V318.966H268.744V320.069L267.718 321.375Z",
    fill: "#554861"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.249,
    y: 311.758,
    width: 112.089,
    height: 20.2927,
    rx: 10.1463,
    fill: "#CDBCDC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.533,
    y: 349.777,
    width: 169.951,
    height: 41.2054,
    rx: 7.27155,
    fill: "#EEE5F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.982,
    y: 363.26,
    width: 29.6921,
    height: 14.2417,
    rx: 2.12087,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.982,
    y: 363.26,
    width: 29.6921,
    height: 14.2417,
    rx: 2.12087,
    stroke: "#CDBCDC",
    strokeWidth: 0.605962
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.322 368.291C251.02 368.291 251.602 368.536 252.067 369.025C252.538 369.515 252.773 370.118 252.773 370.836C252.773 371.553 252.538 372.157 252.067 372.646C251.602 373.136 251.02 373.381 250.322 373.381H248.301V368.291H250.322ZM250.322 372.421C250.763 372.421 251.122 372.276 251.398 371.985C251.675 371.689 251.813 371.306 251.813 370.836C251.813 370.366 251.675 369.985 251.398 369.694C251.122 369.398 250.763 369.251 250.322 369.251H249.304V372.421H250.322ZM256.572 373.381L256.267 372.465H254.238L253.933 373.381H252.849L254.631 368.291H255.874L257.663 373.381H256.572ZM254.558 371.527H255.954L255.256 369.447L254.558 371.527ZM261.525 368.291L259.78 371.396V373.381H258.784V371.396L257.046 368.291H258.18L259.286 370.414L260.391 368.291H261.525ZM269.406 371.175V372.431H268.812V373.381H267.438V372.431H264.74V371.175L266.632 367.442H268.091L266.199 371.175H267.438V369.903H268.812V371.175H269.406Z",
    fill: "#554861"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.249,
    y: 360.234,
    width: 112.089,
    height: 20.2927,
    rx: 10.1463,
    fill: "#CDBCDC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.533,
    y: 398.254,
    width: 169.951,
    height: 41.2054,
    rx: 7.27155,
    fill: "#EEE5F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.982,
    y: 411.737,
    width: 29.6921,
    height: 14.2417,
    rx: 2.12087,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.982,
    y: 411.737,
    width: 29.6921,
    height: 14.2417,
    rx: 2.12087,
    stroke: "#CDBCDC",
    strokeWidth: 0.605962
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.322 416.767C251.02 416.767 251.602 417.012 252.067 417.502C252.538 417.991 252.773 418.595 252.773 419.312C252.773 420.03 252.538 420.633 252.067 421.123C251.602 421.613 251.02 421.857 250.322 421.857H248.301V416.767H250.322ZM250.322 420.898C250.763 420.898 251.122 420.752 251.398 420.461C251.675 420.166 251.813 419.783 251.813 419.312C251.813 418.842 251.675 418.462 251.398 418.171C251.122 417.875 250.763 417.727 250.322 417.727H249.304V420.898H250.322ZM256.572 421.857L256.267 420.941H254.238L253.933 421.857H252.849L254.631 416.767H255.874L257.663 421.857H256.572ZM254.558 420.003H255.954L255.256 417.924L254.558 420.003ZM261.525 416.767L259.78 419.872V421.857H258.784V419.872L257.046 416.767H258.18L259.286 418.891L260.391 416.767H261.525ZM269.406 419.652V420.907H268.812V421.857H267.438V420.907H264.74V419.652L266.632 415.919H268.091L266.199 419.652H267.438V418.379H268.812V419.652H269.406Z",
    fill: "#554861"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.249,
    y: 408.711,
    width: 112.089,
    height: 20.2927,
    rx: 10.1463,
    fill: "#CDBCDC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2995_8323"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.166992 20.2927C0.166992 9.08536 9.25234 0 20.4597 0H395.874C407.082 0 416.167 9.08534 416.167 20.2927V436H0.166992V20.2927Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2995_8323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 296.104,
    height: 16.9669,
    fill: "white",
    transform: "translate(12.8501 9.27246)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLms);
export default __webpack_public_path__ + "static/media/LMS.d237e3870489350dd63b26da50b8f68c.svg";
export { ForwardRef as ReactComponent };